export default __webpack_public_path__ + "static/media/power-definition.7da48173.jpeg";